import { setupContactEls } from "./contactElsSetup.js";
import { initialiseContactList } from "./contactsView.js";
import { setupScanner } from "./setupScanner.js";

export let topLevelContactList = JSON.parse(localStorage.getItem('contacts'));
export let currentView = 0;

export const parentViewContainer = document.querySelector('.view-container');
export const viewContainers = document.querySelectorAll("[data-view]");
export const viewButtons = document.querySelectorAll(".view-buttons > li");
export const cameraButton = document.querySelector('#camera-button');
export const scanSuccess = document.querySelector('#scan-success');

export function setupViews() {

    viewButtons.forEach((button, i) => {
        button.addEventListener('click', () => {
            if (currentView !== i) {
                parentViewContainer.style.viewTransitionName = 'content';
                function action() {
                    viewContainers.forEach((container) => {
                        container.style.display = 'none';

                    })
                    viewButtons.forEach((viewBtn) => {
                        viewBtn.classList.remove('page-active');
                    })
                    viewContainers[i].style.display = 'grid';
                    viewButtons[i].classList.add('page-active');
                    currentView = i;

                    setTimeout(() => {
                        parentViewContainer.style.viewTransitionName = 'unset';
                    }, 500);
                }

                if (!document.startViewTransition) {
                    action();
                    return;
                }

                document.startViewTransition(() => {
                    action();
                })
            }
        });
    })

    cameraButton.addEventListener('click', () => {
        parentViewContainer.style.viewTransitionName = 'content';
        function action() {
            viewContainers.forEach((container) => {
                container.style.display = 'none';

            })
            viewButtons.forEach((viewBtn) => {
                viewBtn.classList.remove('page-active');
            })
            viewContainers[1].style.display = 'grid';
            viewButtons[1].classList.add('page-active');
            currentView = 1;
            setTimeout(() => {
                parentViewContainer.style.viewTransitionName = 'unset';
            }, 500);
        }

        if (!document.startViewTransition) {
            action();
            return;
        }

        document.startViewTransition(() => {
            action();
        })
    })

    scanSuccess.addEventListener('click', () => {
        parentViewContainer.style.viewTransitionName = 'content';
        function action() {
            viewContainers.forEach((container) => {
                container.style.display = 'none';

            })
            viewButtons.forEach((viewBtn) => {
                viewBtn.classList.remove('page-active');
            })
            viewContainers[0].style.display = 'grid';
            viewButtons[0].classList.add('page-active');
            currentView = 0;
            setTimeout(() => {
                parentViewContainer.style.viewTransitionName = 'unset';
            }, 500);
        }

        if (!document.startViewTransition) {
            action();
            return;
        }

        document.startViewTransition(() => {
            action();
        })
    })

    initialiseContactList();
    setupContactEls();
    setupScanner();
}